import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { cache } from '../../graphql/cache';
import { useQuery, useLazyQuery } from '@apollo/client';
import { GET_AUTH_DATA, LOGIN_USUARIO } from '../../graphql/actions/auth.js';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Face from '@material-ui/icons/Face';
// core components
//import Clearfix from '../../components/UI/Clearfix/Clearfix';
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import CardHeader from '../../components/UI/Card/CardHeader';
import CustomInput from '../../components/UI/CustomInput/CustomInput';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
// Validations
import { isEmpty, length } from '../../util/validators';

import loginPageStyle from '../../assets/jss/coscef/views/loginPageStyle';

const useStyles = makeStyles(loginPageStyle);

const LoginPage = (props) => {
  const classes = useStyles();
  const [formUsuario, setFormUsuario] = useState('');
  const [formContrasena, setFormContrasena] = useState('');
  const [loginForm, setLoginForm] = useState({
    usuario: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    contrasena: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, length({ min: 6 })],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const inputChangeHandler = (input, value) => {
    let isValid = true;
    for (const validator of loginForm[input].validators) {
      isValid = isValid && validator(value);
      if (input === 'usuario') {
        if (isValid) setFormUsuario('success');
        else setFormUsuario('error');
      }
      if (input === 'contrasena') {
        if (isValid) setFormContrasena('success');
        else setFormContrasena('error');
      }
    }
    const updatedForm = {
      ...loginForm,
      [input]: {
        ...loginForm[input],
        valid: isValid,
        value: value,
      },
    };
    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setLoginForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const {
    data: { getAuthData },
  } = useQuery(GET_AUTH_DATA);

  const [loginUsuario, { loading, error }] = useLazyQuery(LOGIN_USUARIO, {
    errorPolicy: 'all',
    onCompleted(data) {
      const expirationDate = new Date(
        new Date().getTime() + data.loginUsuario.expiresIn * 1000
      );
      localStorage.setItem('token', data.loginUsuario.token);
      localStorage.setItem('usuario', data.loginUsuario.usuario);
      localStorage.setItem('usuarioId', data.loginUsuario.usuarioId);
      localStorage.setItem('avatar', data.loginUsuario.avatar);
      localStorage.setItem('expirationDate', expirationDate);

      cache.writeQuery({
        query: GET_AUTH_DATA,
        data: {
          getAuthData: {
            isLoggedIn: !!localStorage.getItem('token'),
            loggedUser: data.loginUsuario.usuario,
            loggedUserID: data.loginUsuario.usuarioId,
            loggedUserAvatar: data.loginUsuario.avatar,
            expiresTokenIn: expirationDate,
          },
        },
      });

      props.history.push('/');
    },
  });

  const loginHandler = (e) => {
    e.preventDefault();
    loginUsuario({
      variables: {
        usuario: loginForm.usuario.value,
        contrasena: loginForm.contrasena.value,
      },
    });
  };

  let isAuthRedirect = null;
  if (getAuthData.isLoggedIn) isAuthRedirect = <Redirect to='/' />;
  let showNotification = null;
  let formButtonAccept = (
    <div className={classes.textCenter}>
      <Button
        simple
        color='dark'
        size='lg'
        type='submit'
        disabled={!formIsValid}
      >
        Aceptar
      </Button>
    </div>
  );

  if (loading) formButtonAccept = <Spinner color='gray' />;

  if (error) {
    showNotification = error.graphQLErrors.map(({ message, status, code }) => (
      <Notification
        key={code}
        mostrar={error ? true : false}
        msg={message}
        stt={status}
      />
    ));
  }

  return (
    <div>
      <div className={classes.pageHeader}>
        <div className={classes.container}>
          {isAuthRedirect}
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <form className={classes.form} onSubmit={loginHandler}>
                  <CardHeader
                    color='dark'
                    signup
                    className={classes.cardHeader}
                  >
                    <h4 className={classes.cardTitle}>Iniciar sesión</h4>
                  </CardHeader>
                  <CardBody signup>
                    <CustomInput
                      id='usuario'
                      success={formUsuario === 'success'}
                      error={formUsuario === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => {
                          inputChangeHandler('usuario', event.target.value);
                        },
                        placeholder: 'Usuario',
                        type: 'text',
                        startAdornment: (
                          <InputAdornment position='start'>
                            <Face className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                        autoComplete: 'off',
                      }}
                    />
                    <CustomInput
                      id='contrasena'
                      success={formContrasena === 'success'}
                      error={formContrasena === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => {
                          inputChangeHandler('contrasena', event.target.value);
                        },
                        placeholder: 'Contraseña',
                        type: 'password',
                        startAdornment: (
                          <InputAdornment position='start'>
                            <Icon className={classes.inputIconsColor}>
                              lock_utline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: 'off',
                      }}
                    />
                  </CardBody>
                  {formButtonAccept}
                </form>
              </Card>
            </GridItem>
          </GridContainer>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
